// Sonido "ding" minimalista para notificaciones en primer plano (app abierta).
// Usa Web Audio API (sin archivo externo). Funciona en Android/PC; en iOS solo
// suena tras la primera interacción del usuario (limitación del sistema).

let audioCtx = null;
let unlocked = false;

function getCtx() {
  if (audioCtx) return audioCtx;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    audioCtx = new AC();
  } catch {
    return null;
  }
  return audioCtx;
}

export function playDing() {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  const now = ctx.currentTime;
  const notes = [
    [880, 0],
    [1320, 0.11],
  ];
  notes.forEach(([freq, t]) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, now + t);
    gain.gain.exponentialRampToValueAtTime(0.22, now + t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + t + 0.33);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(now + t);
    osc.stop(now + t + 0.38);
  });
}

function unlock() {
  if (unlocked) return;
  const ctx = getCtx();
  if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {});
  unlocked = true;
  window.removeEventListener("pointerdown", unlock);
  window.removeEventListener("keydown", unlock);
}

export function initNotifySound() {
  if (typeof window === "undefined") return;
  window.addEventListener("pointerdown", unlock);
  window.addEventListener("keydown", unlock);
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.addEventListener("message", (ev) => {
      if (ev.data && ev.data.type === "uaicard-push") playDing();
    });
  }
}
